import React from 'react';
import AssistantForm from '../../components/AssistantForm/AssistantForm';
import ScreenLayout from '../../layout/ScreenLayout/ScreenLayout';

export default function AssistantsScreen() {
	return (
		<ScreenLayout>
			<AssistantForm />
		</ScreenLayout>
	);
}
